import { UIStoreGiftOverlayController } from '../../../shared/scripts/store/gift/UIStoreGiftOverlayController.ts';
import { uiManager } from '../EntryHomepage.ts';
import { Scene } from '../ui_html/UISceneTypes.ts';
import { UIStoreGiftBaseSelectionController } from '../../../shared/scripts/store/gift/UIStoreGiftBaseSelectionController.ts';
import { GiftingFlowAnalytics } from '../../../../shared/entity_datas/EntityDatas.ts';
import { DiscordInstance } from '../discord/DiscordInstance.ts';
import { SDKRequest } from '../../../../shared/DiscordActivityTypes.ts';
import { UIAPIEndpoints } from '../../../shared/scripts/network/UIAPIEndpoints.ts';
import { UIAjaxWrapper } from '../../../shared/scripts/network/UIAjaxWrapper.ts';
import { StorageWrapper } from '../../../shared/scripts/StorageWrapper.ts';
import { StoreProductType } from '../../../../shared/store/BaseColonistStoreProduct.ts';
import { sendPurchaseSessionStartedAnalytic } from '../../../shared/scripts/analytics/sendPurchaseFunnelAnalytic.ts';
export class UIDStoreGiftOverlayController extends UIStoreGiftOverlayController {
    init() {
        this.createHeaderSection();
        this.createBodySection();
    }
    // eslint-disable-next-line class-methods-use-this
    async executeCheckout(giftTier, giftPurchaseData) {
        const result = await UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.apiSaveGiftMetadata(), undefined, giftPurchaseData);
        if (result == undefined) return;
        const giftMetadataId = result.json;
        StorageWrapper.setGiftMetadataId(giftMetadataId);
        sendPurchaseSessionStartedAnalytic({
            storeProductType: StoreProductType.OneTimePurchase,
            productType: giftTier,
            method: 'discord'
        });
        UIStoreGiftBaseSelectionController.sendGiftFlowAnalytics(GiftingFlowAnalytics.SuccessfulCheckoutClick);
        DiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.PurchaseGift, giftTier);
    }
    // eslint-disable-next-line class-methods-use-this
    goToHomepage() {
        uiManager.sceneController.loadScene(Scene.MainPage);
    }
    // eslint-disable-next-line class-methods-use-this
    hide() {
        uiManager.sceneController.loadScene(Scene.DiscordStore);
    }
    // eslint-disable-next-line class-methods-use-this
    show() {
        uiManager.sceneController.loadScene(Scene.DiscordGifting);
    }
}
